"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Talenzap APIs
 * API documentation for the backend services of Talenzap
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.CompetitionDtoStatusEnum = void 0;
exports.CompetitionDtoStatusEnum = {
    Draft: 'draft',
    Published: 'published',
    Upcoming: 'upcoming',
    Live: 'live',
    Completed: 'completed',
    Ended: 'ended',
    Cancelled: 'cancelled'
};
